import supportApi from '@/api/support'
import { SUPPORT_BRANCH_IDS } from '@/components/support/config'
import { PRESENCE_CHANNEL, subscribe } from '@/services/SupportRealtime'

// FAKT Support в CRM: кто я для поддержки (/me: присутствие, часы, непрочитанные ответы филиала)
// и открыта ли форма «Написать в поддержку». Экраны поддержки берут общее отсюда.

const state = {
  me: null,
  // Число от виджета (fakt-support:unread) свежее /me: виджет слушает сокет филиала.
  unreadFromWidget: null,
  formOpen: false,
  // Счётчик отправленных форм: страница «Обращения филиала» перечитывает список.
  formSentTick: 0,
  // «Написать в поддержку» в шторке: виджет открывает «Новое обращение» или, пока виджет без
  // чата (до T08), открывается форма.
  newAppealTick: 0,
  // Кнопка чата видна (есть филиал, не оформление заказа): плавающие кнопки CRM уходят над неё.
  chatButtonVisible: false,
  presenceSubscribed: false,
}

const getters = {
  me: state => state.me,
  presence: state => state.me?.presence || null,
  schedule: state => state.me?.presence?.schedule || null,
  branch: state => state.me?.branch || null,
  appealsUnread: state => state.unreadFromWidget ?? state.me?.counters?.appealsUnread ?? 0,
  // ВРЕМЕННО: поддержка только в филиалах из VUE_APP_SUPPORT_BRANCH_IDS (components/support/config.js).
  // Все точки входа поддержки проверяют этот геттер. Филиал ещё не выбран при заданном списке - false.
  enabled: (state, getters, rootState, rootGetters) =>
    SUPPORT_BRANCH_IDS === null || SUPPORT_BRANCH_IDS.has(Number(rootGetters['branches/getGlobalFilialId'])),
}

const mutations = {
  setMe (state, me) {
    state.me = me
  },
  setPresence (state, presence) {
    if (state.me) state.me = { ...state.me, presence }
  },
  setUnread (state, count) {
    state.unreadFromWidget = count
  },
  setFormOpen (state, value) {
    state.formOpen = value
  },
  formSent (state) {
    state.formSentTick++
  },
  requestNewAppeal (state) {
    state.newAppealTick++
  },
  setChatButtonVisible (state, value) {
    state.chatButtonVisible = value
  },
  setPresenceSubscribed (state) {
    state.presenceSubscribed = true
  },
}

const actions = {
  /** Сервис поддержки недоступен - карточка в шторке просто без часов и бейджа. */
  async loadMe ({ commit, state }) {
    try {
      commit('setMe', await supportApi.me())
    } catch {
      return
    }
    if (!state.presenceSubscribed) {
      commit('setPresenceSubscribed')
      subscribe(PRESENCE_CHANNEL, { 'presence.changed': presence => commit('setPresence', presence) })
    }
  },
  openForm ({ commit }) {
    commit('setFormOpen', true)
  },
  closeForm ({ commit }) {
    commit('setFormOpen', false)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
